/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof Account
     */
    expiredAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    provider?: AccountProviderEnum;
}


/**
 * @export
 */
export const AccountProviderEnum = {
    Google: 'google',
    GoogleScopedAuth: 'google-scoped-auth',
    AzureAd: 'azure-ad',
    AzureAdScopedAuth: 'azure-ad-scoped-auth',
    Yahoo: 'yahoo',
    YahooScopedAuth: 'yahoo-scoped-auth'
} as const;
export type AccountProviderEnum = typeof AccountProviderEnum[keyof typeof AccountProviderEnum];


/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): value is Account {
    return true;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'expiredAt': json['expired_at'] == null ? undefined : (new Date(json['expired_at'])),
        'provider': json['provider'] == null ? undefined : json['provider'],
    };
}

export function AccountToJSON(json: any): Account {
    return AccountToJSONTyped(json, false);
}

export function AccountToJSONTyped(value?: Account | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'expired_at': value['expiredAt'] == null ? value['expiredAt'] : value['expiredAt'].toISOString(),
        'provider': value['provider'],
    };
}

